import { Translation } from '../types';

export const sl: Translation = {
  common: {
    loading: 'Nalaganje...',
    error: 'Napaka',
    cancel: 'Prekliči',
    save: 'Shrani',
    close: 'Zapri',
    search: 'Išči',
    reload: 'Ponovno naloži',
    logout: 'Odjava',
    dashboard: 'Nadzorna plošča',
    products: 'Izdelki',
    settings: 'Nastavitve',
    language: 'Jezik',
    businessHours: 'Delovni čas',
    back: 'Nazaj',
    selectAll: 'Izberi vse',
    deselectAll: 'Počisti izbor',
    success: 'Uspeh',
    selected: 'Izbrano',
    confirm: 'Potrdi',
    required: 'Obvezno',
    requiredMarker: '*',
    previous: 'Prejšnja',
    next: 'Naslednja',
    allRightsReserved: 'Vse pravice pridržane.',
  },
  auth: {
    login: 'Prijava',
    email: 'E-poštni naslov',
    password: 'Geslo',
    loginButton: 'Prijavi se',
    loggingIn: 'Prijavljanje...',
    loginSuccess: 'Prijava uspešna',
    loginError: 'Napačen e-poštni naslov ali geslo',
    invalidEmail: 'Prosimo, vnesite veljaven e-poštni naslov',
    requiredFields: 'Prosimo, izpolnite vsa obvezna polja',
    demoAccount: 'Demo račun:',
    loginDescription: 'Vnesite podatke za prijavo',
    welcomeMessage: 'Dobrodošli v B2B sistemu naročanja',
    // Registration
    register: 'Registracija',
    createAccount: 'Ustvari račun',
    confirmPassword: 'Potrdi geslo',
    passwordRequirements: 'Geslo mora vsebovati vsaj 8 znakov, velike in male črke, številke in posebne znake',
    passwordsDoNotMatch: 'Gesli se ne ujemata',
    registrationSuccess: 'Registracija uspešna',
    registrationDescription: 'Registrirajte poslovni račun',
    alreadyHaveAccount: 'Že imate račun?',
    signIn: 'Prijavite se',
    dontHaveAccount: 'Nimate računa?',
    creatingAccount: 'Ustvarjanje računa...',
    registrationNote: 'Opomba:',
    registrationNotePoints: {
      erpLinking: 'Če imate obstoječ poslovni račun, bo vaš e-poštni naslov samodejno povezan',
      companyEmail: 'Za registracijo uporabite svoj poslovni e-poštni naslov',
      contactSupport: 'Kontaktirajte podporo, če potrebujete pomoč pri registraciji'
    },
    b2bUsers: 'Uporabniki B2B računa:',
    registeredEmail: 'Registriran e-poštni naslov',
    registeredPassword: 'Geslo nastavljeno ob registraciji',
    b2bCustomerRequired: 'Ta e-poštni naslov ni registriran kot poslovna stranka. Prosimo, najprej kontaktirajte prodajo za vzpostavitev poslovnega odnosa.',
    b2bVerificationError: 'Statusa poslovne stranke ni bilo mogoče preveriti. Prosimo, kontaktirajte podporo.',
    // Password Reset
    passwordReset: 'Ponastavitev gesla',
    passwordResetDescription: 'Vnesite svoj e-poštni naslov za pridobitev začasnega gesla',
    getTemporaryPassword: 'Pridobi začasno geslo',
    processing: 'Obdelava...',
    passwordResetComplete: 'Ponastavitev gesla končana',
    temporaryPasswordGenerated: 'Začasno geslo je bilo ustvarjeno',
    temporaryPassword: 'Začasno geslo',
    backToLogin: 'Nazaj na prijavo',
    securityNotice: 'Varnostno obvestilo:',
    securityNotePoints: {
      keepSecret: 'Začasnega gesla ne delite z drugimi',
      changeAfterLogin: 'Po prijavi obvezno spremenite geslo',
      expires24Hours: 'Začasno geslo poteče po 24 urah'
    },
    resetNote: 'Opomba:',
    resetNotePoints: {
      registeredEmail: 'Vnesite registriran e-poštni naslov',
      passwordDisplayed: 'Začasno geslo bo prikazano na zaslonu',
      changeRequired: 'Po prijavi je obvezna sprememba gesla'
    },
    copied: 'Kopirano',
    copySuccessMessage: 'Začasno geslo kopirano v odložišče.',
    forgotPassword: 'Ste pozabili geslo?',
    // Password Reset Email Request
    sendResetLink: 'Pošlji povezavo za ponastavitev',
    sendingEmail: 'Pošiljanje e-pošte...',
    emailSent: 'E-pošta poslana',
    emailSentMessage: 'Če ta e-poštni naslov obstaja v našem sistemu, boste kmalu prejeli povezavo za ponastavitev.',
    emailNotSent: 'E-pošta ni bila poslana',
    emailSentInfo: 'Preverite mapo prejeto in mapo z vsiljeno pošto',
    checkEmail: 'Preverite e-pošto',
    emailInstructions: 'Navodila za ponastavitev gesla so bila poslana',
    nextSteps: 'Naslednji koraki:',
    nextStepsList: {
      checkInbox: 'Preverite mapo prejeto in mapo z vsiljeno pošto',
      clickLink: 'Kliknite na povezavo za ponastavitev v e-pošti',
      linkExpires: 'Povezava poteče v 24 urah',
      contactSupport: 'Kontaktirajte podporo, če e-pošte ne prejmete',
      rateLimitInfo: 'Omejeno na 3 zahtevke na uro'
    },
    // Password Reset Completion
    resetLinkSent: 'Povezava za ponastavitev poslana',
    resetSuccess: 'Geslo je bilo ponastavljeno',
    passwordUpdated: 'Geslo posodobljeno',
    passwordUpdateMessage: 'Vaše geslo je bilo posodobljeno. Zdaj se lahko prijavite z novim geslom.',
    loginWithNewPassword: 'Prijava z novim geslom',
    // Reset Token Page
    resetToken: 'Ponastavi geslo',
    invalidToken: 'Neveljavna koda za ponastavitev',
    expiredToken: 'Koda za ponastavitev je potekla',
    tokenValid: 'Koda za ponastavitev je veljavna',
    newPassword: 'Novo geslo',
    confirmNewPassword: 'Potrdi novo geslo',
    updatePassword: 'Posodobi geslo',
    updatingPassword: 'Posodabljanje gesla...',
    passwordMismatch: 'Gesli se ne ujemata',
    resetInstructions: 'Vnesite novo geslo za dokončanje ponastavitve',
  },
  accountInfo: {
    title: 'Podatki o računu',
    loading: 'Nalaganje podatkov o računu...',
    error: 'Napaka',
    errorMessage: 'Podatkov o računu ni bilo mogoče pridobiti',
    back: 'Nazaj',
    basicInfo: 'Osnovni podatki',
    name: 'Ime',
    email: 'E-poštni naslov',
    contactId: 'ID stranke Knitido',
    contactNumber: 'Kontaktna številka',
    noInfo: 'Ni podatkov',
    companyInfo: 'Podatki o podjetju',
    company: 'Ime podjetja',
    position: 'Delovno mesto',
    vatId: 'Davčna številka',
    billingAddress: 'Naslov za račun',
    deliveryAddress: 'Naslov za dostavo',
    addressInfo: 'Podatki o naslovu',
    billingDescription: 'Naslov za račune in pogodbene dokumente',
    deliveryDescription: 'Privzeti naslov za dostavo izdelkov',
    sameAsBilling: '※ Enako kot naslov za račun',
    sameAsDelivery: '※ Enako kot naslov za dostavo',
    companyName: 'Ime podjetja',
    contactPerson: 'Kontaktna oseba',
    address: 'Naslov',
    phoneNumber: 'Telefonska številka',
    billingUsage: 'Uporablja se za račune, pogodbe in druge pomembne dokumente',
    deliveryUsage: 'Uporablja se kot privzeti naslov za dostavo naročenih izdelkov',
    alsoUsedForDelivery: 'Uporablja se tudi kot cilj dostave',
    accountType: 'Tip računa',
    addressId: 'ID naslova',
    // Address editing functionality
    edit: 'Uredi',
    editDeliveryAddress: 'Uredi naslov za dostavo',
    editDeliveryDescription: 'Posodobite podatke o naslovu za dostavo',
    newDeliveryAddress: 'Dodaj nov naslov za dostavo',
    newDeliveryDescription: 'Vnesite podrobnosti novega naslova za dostavo',
    noDeliveryAddress: 'Naslov za dostavo ni nastavljen',
    success: 'Uspeh',
    addressUpdated: 'Naslov za dostavo posodobljen',
    updateError: 'Naslova za dostavo ni bilo mogoče posodobiti',
    requiredFields: 'Prosimo, izpolnite vsa obvezna polja',
    firstName: 'Ime',
    lastName: 'Priimek',
    streetAddress: 'Ulica in hišna številka',
    streetAddress2: 'Ulica in hišna številka 2',
    city: 'Mesto',
    country: 'Država',
    selectCountry: 'Izberi državo...',
    searchCountry: 'Išči državo...',
    noCountryFound: 'Država ni najdena.',
    postalCode: 'Poštna številka',
    companyNamePlaceholder: 'Vnesite ime podjetja',
    firstNamePlaceholder: 'Ime',
    lastNamePlaceholder: 'Priimek',
    streetAddressPlaceholder: 'Vnesite ulico in hišno številko',
    streetAddress2Placeholder: 'Stanovanje, apartma, itd.',
    cityPlaceholder: 'Vnesite mesto',
    postalCodePlaceholder: 'Vnesite poštno številko',
    billingNotEditable: 'Naslova za račun ni mogoče urejati.',
    billingContactSupport: 'Za spremembe kontaktirajte podporo.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} naslovov za dostavo',
    noDeliveryAddresses: 'Ni registriranih naslovov za dostavo',
    defaultAddress: 'Privzeto',
    selectDeliveryAddress: 'Izberi naslov za dostavo',
    addNewAddress: 'Dodaj nov naslov',
    editAddress: 'Uredi naslov',
    deleteAddress: 'Izbriši naslov',
    confirmDelete: 'Potrdi izbris',
    confirmDeleteMessage: 'Ali ste prepričani, da želite izbrisati ta naslov? Tega dejanja ni mogoče razveljaviti.',
    addressAddedSuccess: 'Naslov za dostavo dodan',
    addressDeletedSuccess: 'Naslov za dostavo izbrisan',
    deleteError: 'Naslova za dostavo ni bilo mogoče izbrisati',
    saving: 'Shranjevanje...',
    cancel: 'Prekliči',
    saveChanges: 'Shrani spremembe',
    selectedDeliveryAddress: 'Izbran naslov za dostavo',
  },
  dashboard: {
    title: 'Poslovni partner',
    subtitle: 'Sistem za naročanje izdelkov',
    welcome: 'Dobrodošli,',
    welcomeMessage: 'Dobrodošli v sistemu naročanja za poslovne partnerje. Tukaj lahko naročate izdelke.',
    productCatalog: 'Katalog izdelkov',
    productCatalogDesc: 'Brskanje in naročanje razpoložljivih izdelkov',
    viewProducts: 'Prikaži izdelke',
    orderHistory: 'Zgodovina naročil',
    orderHistoryDesc: 'Ogled preteklih naročil',
    accountSettings: 'Nastavitve računa',
    accountSettingsDesc: 'Upravljanje podatkov o računu',
    comingSoon: 'Kmalu na voljo',
    infoTitle: 'O uporabi',
    orderingInfo: 'Naročanje izdelkov',
    orderingDesc: 'Izberite izdelke iz kataloga ter določite velikost in barvo. Podatki o zalogi so na voljo v realnem času.',
    supportInfo: 'Podpora',
    supportDesc: 'Kontaktirajte nas, če imate vprašanja.',
    viewOrderHistory: 'Prikaži zgodovino naročil',
    viewOrders: 'Prikaži naročila',
    accountInfo: 'Podatki o računu',
    accountInfoDesc: 'Ogled podrobnosti računa',
    viewDetails: 'Prikaži podrobnosti',
    supportEmail: 'b2b-partner @knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Ponedeljek-petek 9:00 - 15:00 CET',
    bulkImportDesc: 'Uvoz naročil iz Excel/CSV datotek',
    importOrders: 'Uvozi naročila',
  },
  products: {
    title: 'Seznam izdelkov',
    subtitle: 'Poslovni partner',
    searchPlaceholder: 'Išči po imenu izdelka ali SKU...',
    productId: 'ID izdelka',
    addToCart: 'V košarico',
    selectVariation: 'Izberi različico',
    price: 'Cena',
    priceNetNotice: 'Vse cene so brez DDV',
    stock: 'Zaloga',
    color: 'Barva',
    newProducts: 'Novi izdelki',
    newProductBadge: 'NOVO',
    size: 'Velikost',
    quantity: 'Količina',
    total: 'Skupaj',
    cart: 'Košarica',
    checkout: 'Na blagajno',
    csvMode: 'CSV hitri način',
    csvInfo: 'Podatki o izdelkih pridobljeni iz CSV podatkov',
    csvUploadDate: 'Datum nalaganja CSV:',
    stockNote: '※ Podatki o zalogi se pridobijo ob izbiri različic izdelka',
    noProducts: 'Ni najdenih izdelkov',
    noProductsDesc: 'Spremenite iskalne kriterije ali naložite CSV datoteko za hitrejše delovanje.',
    retry: 'Poskusi znova',
    pagination: 'elementov',
    variations: 'različice',
    stockFetchError: 'Napaka pri pridobivanju zaloge',
    stockFetchFailed: 'Pridobivanje zaloge ni uspelo',
    stockFetchFailedDesc: 'Podatkov o zalogi ni bilo mogoče pridobiti. Prikazana bo CSV zaloga.',
    stockFetched: 'Podatki o zalogi pridobljeni',
    totalStock: 'Skupna zaloga',
    noStockAll: 'Vse različice so brez zaloge',
    noStockData: 'Podatki o zalogi niso bili vrnjeni',
    stockFetchErrorDesc: 'Prišlo je do napake pri pridobivanju podatkov o zalogi',
    selectionError: 'Napaka pri izbiri',
    enterQuantity: 'Prosimo, vnesite količino',
    addedToCart: 'Dodano v košarico',
    typesAdded: ' dodanih tipov izdelkov',
    addToCartError: 'Napaka pri dodajanju v košarico',
    addToCartErrorDesc: 'Prosimo, poskusite znova',
    loadingStock: 'Nalaganje podatkov o zalogi',
    csvDataInfo: 'Prikazovanje podatkov iz CSV (ne dejanskih ravni zaloge)',
    invalidDataFormat: 'Format podatkov o izdelku je neveljaven',
    loadFailed: 'Podatkov o izdelkih ni bilo mogoče naložiti',
    csvUploadComplete: 'Nalaganje CSV končano',
    csvLoadedDesc: ' podatkov o izdelkih naloženih. Podatki o zalogi bodo pridobljeni, ko izberete izdelke.',
    searchTitle: 'Iskanje izdelkov',
    loadingProducts: 'Nalaganje podatkov o izdelkih',
    noProductsCsv: 'V CSV podatkih ni najdenih izdelkov. Prosimo, spremenite iskalne kriterije.',
    paginationDisplay: ' prikazano',
    previous: 'Prejšnja',
    next: 'Naslednja',
    selectionSummary: 'Povzetek izbire',
    selectedQuantity: 'Izbrana količina',
    items: ' elementov',
    viewDetails: 'Prikaži podrobnosti',
    productImage: 'Slika izdelka',
    correspondingVariations: 'Ustrezne različice',
    clickToEnlarge: 'Klikni za povečavo',
    productIdLabel: 'ID izdelka',
    colorLabel: 'Barva',
    filterByCategory: 'Filtriraj po kategoriji',
    allProducts: 'Vsi izdelki',
    applyFilters: 'Uporabi filtre',
    clearFilters: 'Počisti filtre',
    filters: 'Filtri',
    clearAll: 'Počisti vse',
  },
  categories: {
    category_21: 'Nogavice na prste',
    category_23: 'Nekategorizirano',
    category_24: 'Oblačila za telo',
    category_29: 'B2B izdelki',
  },
  productDetail: {
    title: 'Podrobnosti izdelka',
    backToProducts: 'Nazaj na izdelke',
    productNotFound: 'Izdelek ni najden',
    productNotFoundDesc: 'Naveden izdelek ne obstaja ali je bil izbrisan.',
    loading: 'Nalaganje izdelka...',
    imageLoadError: 'Slik ni bilo mogoče naložiti',
    noImages: 'Slike niso na voljo',
    productDescription: 'Opis izdelka',
    colors: 'Barve',
    sizes: 'Velikosti',
    colorCount: 'barve',
    sizeCount: 'velikosti',
    variationCount: 'različice',
    selectVariation: 'Izberi različice',
    descriptionLanguageNote: '※ Opisi izdelkov so na voljo samo v angleščini ali nemščini',
  },
  colors: {
    schwarz: 'Črna',
    weiß: 'Bela',
    grau: 'Siva',
    rot: 'Rdeča',
    blau: 'Modra',
    grün: 'Zelena',
    gelb: 'Rumena',
    rosa: 'Roza',
    lila: 'Vijolična',
    braun: 'Rjava',
    orange: 'Oranžna',
    beige: 'Bež',
    navy: 'Mornarsko modra',
    dunkelblau: 'Temno modra',
    hellblau: 'Svetlo modra',
    dunkelgrau: 'Temno siva',
    hellgrau: 'Svetlo siva',
    bordeaux: 'Bordo',
    türkis: 'Turkizna',
    khaki: 'Kaki',
    mint: 'Meta',
    violett: 'Vijolična',
    anthrazit: 'Antracit',
    blaugrau: 'Modro-siva',
    burgunderrot: 'Bordo rdeča',
    elfenbein: 'Slonovina',
    karminrot: 'Karmin rdeča',
    neongrün: 'Neon zelena',
    gelbgrün: 'Rumeno-zelena',
    pistazie: 'Pistacija',
    // Engelske fargenavn (brukt i Product ID 237, osv.)
    blue: 'Modra',
    ivory: 'Slonovina',
    green: 'Zelena',
    gold: 'Zlata',
    red: 'Rdeča',
  },
  checkout: {
    title: 'Blagajna',
    cartReview: 'Pregled naročila',
    orderSummary: 'Povzetek naročila',
    shippingInfo: 'Podatki o dostavi',
    billingInfo: 'Podatki o plačniku',
    orderNotes: 'Opombe k naročilu',
    orderNotesPlaceholder: 'Posebne zahteve ali opombe...',
    contactPerson: 'Kontaktna oseba',
    phoneNumber: 'Telefonska številka',
    email: 'E-poštni naslov',
    company: 'Podjetje',
    address: 'Naslov',
    city: 'Mesto',
    postalCode: 'Poštna številka',
    country: 'Država',
    deliveryDate: 'Datum dostave',
    urgentDelivery: 'Hitra dostava (3-5 delovnih dni)',
    standardDelivery: 'Standardna dostava (7-10 delovnih dni)',
    placeOrder: 'Oddaj naročilo',
    backToCart: 'Nazaj na izbiro izdelkov',
    requiredField: 'Obvezno polje',
    orderTotal: 'Skupaj naročilo',
    subtotal: 'Vmesni znesek',
    priceNetNotice: 'Vse cene so brez DDV',
    stockReservationNotice: 'Rezervacija zaloge bo opravljena po potrditvi naročila.',
    stockCheckError: 'Napaka pri preverjanju zaloge',
    stockCheckErrorDesc: 'Prišlo je do napake pri preverjanju zaloge. Prosimo, poskusite znova.',
    shipping: 'Dostava',
    shippingCost: 'Strošek dostave',
    tax: 'DDV',
    orderSuccess: 'Naročilo uspešno',
    orderSuccessMessage: 'Vaše naročilo je bilo poslano. Številka naročila: {orderNumber}',
    orderNumber: 'Številka naročila',
    thankYou: 'Hvala za vaše naročilo!',
    orderConfirmation: 'Vaše naročilo je bilo poslano.',
    orderProcessing: 'Po pregledu naše ekipe vam bomo po e-pošti poslali potrditev naročila.',
    orderProcessingMessage: 'Vaše naročilo je bilo poslano. Po pregledu naše ekipe vam bomo po e-pošti poslali potrditev naročila.',
    continueShopping: 'Nadaljuj z nakupovanjem',
    emptyCart: 'Vaša košarica je prazna',
    emptyCartMessage: 'Prosimo, dodajte izdelke v košarico za nadaljevanje',
    stockWarning: 'Opozorilo glede zaloge',
    stockWarningDesc: 'Nekateri izdelki nimajo zadostne zaloge. Prosimo, prilagodite količine.',
    stockError: 'Napaka zaloge',
    stockErrorDesc: 'Obstajajo izdelki z nezadostno zalogo. Prosimo, prilagodite količine.',
    refreshStock: 'Osveži zalogo',
    stockUpdated: 'Zaloga posodobljena',
    stockUpdatedDesc: 'Zaloga je bila posodobljena - spremenjenih {changed} izdelkov',
    stockCheckDesc: 'Prikazani rezultati primerjave z zalogo',
    stockOk: 'Zaloga OK',
    stockShortage: 'Pomanjkanje zaloge',
    requestedQty: 'Zahtevana količina',
    currentStock: 'Trenutna zaloga',
    stockShortageMsg: 'Nezadostna zaloga. Prosimo, prilagodite količino.',
    stockIssueWarning: 'Naročila ni mogoče potrditi zaradi težav z zalogo.',
    stockDataMissing: 'Pridobivanje podatkov o zalogi. Prosimo, počakajte trenutek.',
    outOfStock: 'Razprodano.',
    maxAvailable: 'Največ',
    autoRestored: 'Košarica obnovljena',
    autoRestoredDesc: 'Artikli iz vaše zadnje seje so bili obnovljeni',
    maxQuantityReached: 'Dosežena največja količina zaloge.',
    // ERP Contact Search
    contactSearch: 'Iskanje stika stranke',
    contactSearchDesc: 'Vnesite e-poštni naslov naročnika za pridobitev kontaktnih podatkov',
    emailAddress: 'E-poštni naslov',
    searchButton: 'Išči',
    searching: 'Iskanje',
    contactFound: 'Kontakt najden',
    contactNotFound: 'Kontakt ni najden',
    contactId: 'ID stranke Knitido',
    companyName: 'Podjetje',
    contactPersonLabel: 'Kontaktna oseba',
    addressesFound: 'Najdeni naslovi',
    addressType: 'Tip',
    addressBilling: 'Naslov za račun',
    addressDelivery: 'Naslov za dostavo',
    vatSourceCompany: 'Podatki o podjetju',
    vatSourceBilling: 'Račun',
    vatSourceDelivery: 'Dostava',
    addressOther: 'Drugo',
    addressDetails: 'Naslov',
    loadingAddresses: 'Nalaganje podatkov o naslovu...',
    addressRetrieved: 'Podatki o naslovu pridobljeni',
    addressNotFound: 'Podatki o naslovu niso najdeni',
    addressNotFoundDesc: 'Ni registriranih podatkov o naslovu. Prosimo, vnesite ročno.',
    addressError: 'Napaka pri pridobivanju naslova',
    addressErrorDesc: 'Podatkov o naslovu ni bilo mogoče pridobiti.',
    contactNotConfirmed: 'Kontakt stranke ni potrjen',
    contactNotConfirmedDesc: 'Prosimo, vnesite e-poštni naslov in poiščite kontakt.',
    searchContact: 'Išči kontakt',
    inputError: 'Napaka pri vnosu',
    inputErrorDesc: 'Podatki o dostavi so nepopolni. Prosimo, preverite.',
    processing: 'Obdelava...',
    erpContactSearch: 'Iskanje stika stranke',
    contactSearchError: 'E-poštni naslov se ne ujema z nobenim registriranim kontaktom.',
    // Product Images Toggle
    showProductImages: 'Prikaži slike izdelkov',
    showProductImagesDesc: 'Prikaži slike izdelkov za boljši pregled (lahko podaljša čas nalaganja)',
    // System Registration Info
    systemRegistrationInfo: 'Vaši podatki o stranki',
    editShippingAddress: 'Uredi naslov za dostavo',
    systemRegistrationInfoDesc: 'Vaši registrirani podatki o podjetju. Prosimo, kontaktirajte svojega zastopnika, če morate posodobiti podatke o naslovu za račun.',
    // Order Summary
    regularPrice: 'Redna veleprodajna cena',
    offeredPrice: 'Ponujena cena',
    discount: 'Popust',
    b2bCustomer: 'B2B stranka',
    pattern: 'Vzorec',
    specialPriceApplied: 'Uporabljena posebna cena',
    customerClassification: 'Klasifikacija stranke',
    paymentCondition: 'Plačilni pogoji',
    invoice: 'Račun (NETO 30)',
    prepayment: 'Predplačilo',
    paymentMethod: 'Način plačila',
    invoicePayment: 'Plačilo po računu',
    estimatedSubtotal: 'Ocenjeni vmesni znesek',
    estimatedTotal: 'Ocenjeni skupni znesek',
    orderSummaryDisclaimer: 'Prikazane cene so ocene. Ko prejmemo vaše naročilo, ga bomo pregledali in vam po e-pošti poslali zavezujočo potrditev naročila s končnimi cenami, stroški pošiljanja in davki.',
    searchError: 'Napaka pri iskanju',
    searchErrorDesc: 'Pri iskanju kontakta je prišlo do napake.',
    confirmDeleteItem: 'Odstrani izdelek',
    itemDeleted: 'Izdelek odstranjen',
    confirmDeleteItemDesc: 'Ali ste prepričani, da želite odstraniti naslednji izdelek iz košarice?',
    deleteConfirm: 'Odstrani',
    contactNotes: 'Opombe kontakta',
    contactNotesDesc: 'Imate vprašanja ali posebne zahteve? Sporočite nam (neobvezno)',
    contactNotesLabel: 'Sporočilo',
    contactNotesPlaceholder: 'npr.: Vprašanja o izdelku, posebne zahteve itd.',
    characters: 'znakov',
    contactIdLabel: 'ID stranke Knitido',
    companyLabel: 'Podjetje',
    personLabel: 'Kontaktna oseba',
    emailLabel: 'E-pošta',
    addressTypeLabel: 'Tip',
    destinationLabel: 'Cilj',
    // Shipping Form
    shippingTitle: 'Podatki o dostavi',
    shippingDesc: 'Vnesite naslov za dostavo izdelkov',
    companyRequired: 'Podjetje *',
    contactPersonRequired: 'Kontaktna oseba *',
    emailRequired: 'E-poštni naslov *',
    phoneRequired: 'Telefonska številka *',
    addressRequired: 'Naslov 1 *',
    address2: 'Naslov 2 (Stavba/Soba)',
    postalCodeRequired: 'Poštna številka *',
    cityRequired: 'Mesto *',
    countryRequired: 'Država *',
    selectCountry: 'Izberi državo',
    shippingMethodRequired: 'Način dostave *',
    selectShippingMethod: 'Izberi način dostave',
    urgentDeliveryOption: 'Hitra dostava (dodatni stroški)',
    deliveryNotes: 'Opombe za dostavo',
    deliveryNotesPlaceholder: 'Vnesite želje glede časa dostave ali druge zahteve',
    standardShipping: 'Standardna dostava (3-5 delovnih dni)',
    expressShipping: 'Hitra dostava (1-2 delovna dneva)',
    overnightShipping: 'Dostava čez noč',
    germany: 'Nemčija',
    austria: 'Avstrija',
    switzerland: 'Švica',
    japan: 'Japonska',
    shippingAddressLabel: 'Naslov za dostavo',
    changeDeliveryAddress: 'Spremeni naslov za dostavo',
    selectDeliveryAddress: 'Izberi naslov za dostavo',
    // Shipping Cost Details
    freeShipping: 'Brezplačna dostava',
    shippingError: 'Napaka',
    shippingZone: 'Cona dostave',
    remainingForFreeShipping: '{amount} še do brezplačne dostave',
    moreForFreeShipping: 'več za brezplačno dostavo',
    freeShippingProgress: 'Brezplačna dostava pri',
    andAboveFreeShipping: 'in več za brezplačno dostavo',
    freeShippingAchieved: 'Uporabljena brezplačna dostava',
    threshold: 'in več',
    nextShippingTier: 'Naslednji popust pri dostavi',
    moreForDiscount: 'več za',
    shippingSavings: 'prihranek pri dostavi',
    orderAmountThreshold: 'in več za',
    specialRegionNotice: 'Uporabljena posebna cona dostave',
    defaultShippingApplied: 'Uporabljene standardne cene dostave',
    requestedQuantity: 'Zahtevana količina',
    availableQuantity: 'Razpoložljiva količina',
    orderSubmitError: 'Napaka naročila',
    orderSubmitErrorDesc: 'Naročila ni bilo mogoče oddati',
    upload: {
      title: 'Uvoz Excel/CSV naročila',
      description: 'Naložite Excel ali CSV datoteko s podatki o naročilu',
      dragDropOrClick: 'Povlecite in spustite datoteko sem ali kliknite za izbiro',
      dropHere: 'Spustite datoteko tukaj',
      supportedFormats: 'Podprti formati: Excel (.xlsx, .xls) in CSV (.csv)',
      maxSize: 'Največja velikost datoteke: {size} MB',
      processFile: 'Obdelaj datoteko',
      processing: 'Obdelava datoteke...',
      ready: 'Datoteka pripravljena za predogled',
      readyDescription: 'Vaša datoteka je bila obdelana in je pripravljena za pregled.',
      preview: 'Prikaži predogled',
      errors: {
        fileTooLarge: 'Datoteka je prevelika. Največja velikost: {size} MB',
        invalidFileType: 'Neveljavna vrsta datoteke. Prosimo, naložite Excel ali CSV datoteko',
        uploadFailed: 'Napaka pri nalaganju datoteke',
      },
    },
    // Loading messages
    loadingPage: 'Nalaganje strani...',
    loadingStock: 'Preverjanje zaloge izdelkov...',
    loadingAccount: 'Nalaganje podatkov o računu...',
    loadingError: 'Prišlo je do napake...',
    loadingData: 'Nalaganje podatkov',
    // Toast messages
    addressRetrievedTitle: 'Podatki o naslovu pridobljeni',
    addressSetAsDelivery: ' naslov nastavljen kot cilj dostave.',
    contactFoundDesc: ' je bil prepoznan.'
  },
  orderHistory: {
    title: 'Zgodovina naročil',
    searchPlaceholder: 'Išči po številki naročila ali SKU...',
    noOrders: 'Ni najdenih naročil',
    noOrdersFound: 'Nobeno ujemajoče se naročilo ni bilo najdeno',
    startShopping: 'Prikaži izdelke',
    orderItems: 'Postavke naročila',
    viewDetails: 'Podrobnosti',
    reorder: 'Ponovno naroči',
    orderDate: 'Datum naročila',
    orderStatus: 'Status',
    orderTotal: 'Skupaj naročilo',
    // Status translations
    statusPending: 'Čakanje na plačilo',
    statusProcessing: 'Obdelava',
    statusConfirmed: 'Potrjeno',
    statusShipped: 'Poslano',
    statusDelivered: 'Dostavljeno',
    statusCancelled: 'Preklicano',
    statusReturned: 'Vrnjeno',
    statusRefunded: 'Povrnjeno',
    statusWarranty: 'Garancija',
    statusExchanged: 'Zamenjano',
    statusRepair: 'Popravilo',
    statusUnknown: 'Neznano',
    statusIncomplete: 'Nepopolno',
    statusWaitingPayment: 'Čakanje na plačilo',
    statusInPreparation: 'V pripravi',
    statusClearedShipping: 'Pripravljeno za pošiljanje',
    statusBeingShipped: 'Se pošilja',
    statusOutgoingBooked: 'Izhodno rezervirano',
    statusReturn: 'Vračilo',
    // Additional UI elements
    itemCount: 'artiklov',
    itemCountSingular: 'artikel',
    refreshButton: 'Osveži',
    errorFetchingOrders: 'Zgodovine naročil ni bilo mogoče pridobiti',
    // Payment status features
    paymentStatus: 'Status plačila',
    markAsPaid: 'Označi kot plačano',
    unmarkAsPaid: 'Odstrani oznako plačano',
    paidOn: 'Plačano',
    paymentMarked: 'Plačano',
    notPaid: 'Ni plačano',
    paymentMarkedSuccess: 'Uspešno označeno kot plačano',
    paymentUnmarkedSuccess: 'Oznaka plačano odstranjena',
    paymentUpdateError: 'Statusa plačila ni bilo mogoče posodobiti',
    // Payment date dialog
    paymentDateTitle: 'Vnesite podatke o plačilu',
    paymentDateDescription: 'Vnesite podatke o plačilu za naročilo {orderNumber}',
    paymentDateLabel: 'Datum plačila',
    selectDate: 'Izberi datum',
    paymentDateHelp: 'Izberite datum izvršitve bančnega nakazila',
    paymentMethodLabel: 'Način plačila',
    bankTransfer: 'Bančno nakazilo',
    invoice: 'Račun',
    otherPayment: 'Drugo',
    paymentReferenceLabel: 'Ime nakazila / Referenčna številka',
    paymentReferencePlaceholder: 'npr. Janez Novak, Nakazilo #12345',
    paymentReferenceHelp: 'Vnesite podatke, ki pomagajo pri usklajevanju z bančnimi izpiski',
    notesLabel: 'Opombe',
    notesPlaceholder: 'Vnesite morebitne dodatne informacije o plačilu',
    // Filter options
    filterByPaymentStatus: 'Filtriraj po statusu plačila',
    allOrders: 'Vsa naročila',
    paidOrders: 'Plačana',
    unpaidOrders: 'Neplačana',
    // Sorting options
    sortBy: 'Razvrsti po',
    sortByDate: 'Datum naročila',
    sortByPaymentDate: 'Datum plačila',
    sortByAmount: 'Znesek',
    sortByStatus: 'Status',
  },
  orderDetails: {
    title: 'Podrobnosti naročila',
    notFound: 'Naročilo ni najdeno',
    backToHistory: 'Nazaj na zgodovino naročil',
    orderDate: 'Datum naročila',
    orderItems: 'Postavke naročila',
    deliveryStatus: 'Status dostave',
    estimatedDelivery: 'Ocenjena dostava',
    deliveredOn: 'Dostavljeno',
    downloadInvoice: 'Prenesi račun',
    statusDelivered: 'Dostavljeno',
    statusShipped: 'Poslano',
    statusConfirmed: 'Potrjeno',
    statusCancelled: 'Preklicano',
    errorFetchingDetails: 'Podrobnosti naročila ni bilo mogoče pridobiti',
  },
  company: {
    name: 'Poslovni partner',
    tagline: 'Sistem za poslovne partnerje',
    copyright: '© 2025 Sistem za poslovne partnerje. Vse pravice pridržane.',
  },
  footer: {
    phone: 'Telefon',
    email: 'E-pošta',
    countries: {
      DE: 'Nemčija',
      AT: 'Avstrija',
      CH: 'Švica',
      FR: 'Francija',
      IT: 'Italija',
      ES: 'Španija',
      NL: 'Nizozemska',
      BE: 'Belgija',
      PL: 'Poljska',
      SE: 'Švedska',
      NO: 'Norveška',
      FI: 'Finska',
      DK: 'Danska',
      LT: 'Litva',
      LV: 'Latvija',
      EE: 'Estonija',
    },
  },
  cart: {
    newCart: 'Nova košarica',
    currentCart: 'Trenutna košarica',
    modified: 'spremenjeno',
    lastSaved: 'Nazadnje shranjeno',
    unsavedChanges: 'neshranjene spremembe',
    saveCart: 'Shrani košarico',
    loadCart: 'Naloži košarico',
    deleteCart: 'Izbriši košarico',
    startNewCart: 'Začni novo košarico',
    savedCarts: 'Shranjene košarice',
    cartSaved: 'Košarica shranjena',
    cartDeleted: 'Košarica izbrisana',
    confirmDeleteCart: 'Izbrišem košarico?\n\nTega dejanja ni mogoče razveljaviti.',
    confirmSwitchCart: 'Trenutna košarica ima neshranjene spremembe.\n\nNalaganje druge košarice bo povzročilo izgubo trenutnih sprememb.\n\nNadaljuj?',
    confirmSwitchCartTitle: 'Zamenjaj košarico',
    confirmNewCart: 'Trenutna košarica ima neshranjene spremembe.\n\nZačetek nove košarice bo povzročil izgubo trenutnih sprememb.\n\nNadaljuj?',
    confirmNewCartTitle: 'Začni novo košarico',
    confirmClearCart: 'Izpraznim košarico?\n\nOdstranjenih bo {count} izdelkov.\n\nTega dejanja ni mogoče razveljaviti.',
    confirmClearCartTitle: 'Izprazni košarico',
    autoSaved: 'Samodejno shranjeno',
    itemsWillBeRemoved: 'izdelkov bo odstranjenih',
    changesWillBeLost: 'spremembe bodo izgubljene',
    continueQuestion: 'Nadaljuj?',
    cartStatus: 'Status košarice',
    cartName: 'Ime košarice',
    cartNamePlaceholder: 'npr.: Naročilo konec meseca',
    cartNameRequired: 'Prosimo, vnesite ime košarice',
    saveCartDescription: 'Poimenujte trenutno košarico in jo shranite. Kasneje jo lahko naložite.',
    cancelCart: 'Prekliči košarico',
    proceedToCheckout: 'Na blagajno',
    emptyCart: 'Košarica je prazna',
    erpDown: 'Sistem naročil je nedostopen. Poskusite znova pozneje.',
    erpDegraded: 'Sistem je trenutno nestabilen. Naročila se morda ne bodo izvedla.',
    erpDownSaveHint: 'Shranite košarico in naročite, ko bo sistem obnovljen.',
    erpSaveCart: 'Shrani košarico',
  },
  nav: {
    dashboard: 'Nadzorna plošča',
    products: 'Izdelki',
    orderHistory: 'Naročila',
    account: 'Podatki o računu',
    bulkImport: 'Množični uvoz',
  },
  settings: {
    selectLanguage: 'Izberite jezik',
    languagePreferenceSaved: 'Vaša izbira bo shranjena v vašem računu za prihodnje obiske.',
  },
  reorder: {
    allItemsAdded: '{count} izdelkov dodanih v košarico',
    partialSuccess: '{added} izdelkov dodanih. {failed} izdelkov ni bilo mogoče dodati',
    allItemsFailed: 'Izdelkov ni bilo mogoče dodati v košarico',
    error: 'Napaka pri ponovnem naročilu',
    itemDiscontinued: '{name} ({color}/{size}) je opuščen',
    itemOutOfStock: '{name} ({color}/{size}) je razprodan',
    partialStock: '{name} ({color}/{size}) na voljo le {available}',
    confirmReorder: 'Potrdi ponovno naročilo',
    confirmReorderMessage: 'Dodam izdelke iz tega naročila v košarico?',
    addingToCart: 'Dodajanje v košarico...',
    checkingStock: 'Preverjanje zaloge...',
    checkoutTitle: 'Izdelki dodani v košarico',
    checkoutDescription: '{count} izdelkov je bilo dodanih v vašo košarico. Želite nadaljevati na blagajno?',
  },
  bulkImport: {
    instructions: 'Kako uvoziti naročila',
    step1: 'Prenesite datoteko predloge naročila',
    step2: 'Vnesite podatke o naročilu s SKU in količino',
    step3: 'Shranite kot Excel (.xlsx) ali CSV datoteko',
    step4: 'Naložite datoteko s pomočjo spodnjega obrazca',
    step5: 'Preglejte in potrdite svoje naročilo',
    downloadTemplate: 'Prenesi predlogo',
    downloadExcelTemplate: 'Prenesi Excel predlogo',
    downloadCsvTemplate: 'Prenesi CSV predlogo',
    formatGuide: 'Vodnik po formatih datotek',
    requiredColumns: 'Obvezni stolpci',
    skuDescription: 'SKU koda izdelka',
    quantityDescription: 'Količina naročila (pozitivno celo število)',
    optionalColumns: 'Izbirni stolpci',
    notesDescription: 'Interne opombe (npr. št. naročilnice, referenca) - samo za vašo evidenco',
    formatNote: 'Prva vrstica mora vsebovati naslove stolpcev. Podatki se začnejo v drugi vrstici.',
    parseSuccess: 'Uspešno obdelanih {count} postavk iz datoteke',
    parseError: 'Napaka pri obdelavi',
    validationError: 'Napaka pri preverjanju',
    validationErrorGuidance: 'Prosimo, kliknite gumb "{showPreviewButton}" za pregled podrobnosti.',
    warnings: 'Opozorila',
    itemsParsed: 'Uspešno obdelanih {count} postavk:',
    andMore: '...in {count} dodatnih postavk',
    validationSummary: 'Povzetek preverjanja',
    duplicateSKUs: 'Najdeni podvojeni SKU-ji',
    skuFormat: 'SKU mora vsebovati samo črke, številke in vezaje',
    quantityRange: 'Količina mora biti med 1 in 9999',
    maxRows: 'Dovoljenih največ 1000 vrstic',
    rowsSkipped: '{count} vrstic je bilo preskočenih zaradi napak',
    previewTitle: 'Predogled naročila',
    previewDescription: 'Preden nadaljujete, preglejte in uredite podatke o naročilu',
    proceedToCart: 'Dodaj v košarico',
    // File parsing messages
    fileEmpty: 'Datoteka je prazna ali ne vsebuje podatkov',
    fileTooManyRows: 'Datoteka vsebuje preveč vrstic ({current}). Največ dovoljeno: {max}',
    invalidRowFormat: 'Neveljaven format vrstice',
    missingColumns: 'Manjkajo obvezni stolpci (SKU in Količina)',
    missingSku: 'Manjka SKU',
    invalidSkuFormat: 'Neveljaven SKU format: "{sku}" (mora ustrezati vzorcu: {pattern})',
    skuTooLong: 'SKU predolg: "{sku}" (največ 50 znakov)',
    invalidQuantity: 'Neveljavna količina: "{quantity}" ni številka',
    quantityTooLow: 'Količina prenizka: {quantity} (najmanj: {min})',
    quantityTooHigh: 'Količina previsoka: {quantity} (največ: {max})',
    notesRequired: 'Polje za opombe je obvezno',
    noValidData: 'Veljavnih podatkov ni mogoče najti. Prosimo, preverite format datoteke.',
    row: 'Vrstica {row}: {errors}',
    rowErrors: '...in {count} dodatnih napak',
    duplicateSkuInRows: 'Podvojen SKU "{sku}" najden v vrsticah: {rows}',
    quantityExceedsMax: 'Vrstica {row}: Količina {quantity} presega največjo dovoljeno ({max})',
    quantityBelowMin: 'Vrstica {row}: Količina {quantity} je pod minimalno zahtevano ({min})',
    // Validation messages
    unsupportedFileFormat: 'Nepodprt format datoteke. Prosimo, naložite CSV ali Excel datoteko.',
    csvParsingErrors: 'Prišlo je do napak pri obdelavi CSV',
    failedToParseFile: 'Datoteke ni bilo mogoče obdelati',
    failedToParseExcel: 'Excel datoteke ni bilo mogoče obdelati',
    failedToReadFile: 'Datoteke ni bilo mogoče prebrati',
    unknownError: 'Prišlo je do neznane napake',
    totalRows: 'Skupaj vrstic',
    valid: 'Veljavne',
    invalid: 'Neveljavne',
    skipped: 'Preskočene',
    // SKU validation
    skuValidationError: 'Napaka pri validaciji SKU',
    skuValidationFailed: 'Validacija SKU-jev ni uspela. Še vedno lahko nadaljujete, vendar nekateri izdelki morda niso na voljo.',
    skuNotFound: 'SKU ni najden v bazi podatkov',
    skusNotFound: '{count} SKU-jev ni najdenih v bazi podatkov',
    itemsHaveInsufficientStock: '{count} izdelkov nima zadostne zaloge',
    validatingSKUs: 'Preverjanje izdelkov...',
    unvalidatedChanges: 'Imate nepreverjene spremembe. Prosimo, ponovno preverite pred dodajanjem v košarico.',
    revalidate: 'Ponovno preveri',
    validating: 'Preverjanje...',
    validationSuccess: 'Vsi izdelki so veljavni',
    validationComplete: 'Preverjanje končano',
    validationResultSummary: 'Najdenih {errors} napak, {warnings} opozoril',
    // Table headers
    actions: 'Dejanja',
    notes: 'Opombe',
    // Status filter
    all: 'Vse',
    hasErrors: 'Ima napake',
    // Selection summary
    selected: 'izbrano',
    errors: 'napak',
    // Pagination
    page: 'Stran {current} od {total}',
    previous: 'Prejšnja',
    next: 'Naslednja',
    noResults: 'Ni rezultatov.',
    // Cart integration
    noValidItems: 'Ni veljavnih izdelkov',
    allItemsHaveErrors: 'Vsi izdelki imajo napake pri preverjanju. Prosimo, popravite jih pred nadaljevanjem.',
    dataLoadingError: 'Napaka pri nalaganju podatkov',
    failedToLoadProductData: 'Podatkov o izdelkih ni bilo mogoče naložiti. Prosimo, poskusite znova.',
    itemsAddedToCart: '{count} izdelkov dodanih v košarico',
    itemsAddedMessage: 'V košarico dodanih {count} izdelkov',
    someSkusNotFound: '{count} SKU-jev ni bilo mogoče najti.',
    noItemsAdded: 'Noben izdelek ni bil dodan',
    couldNotFindProducts: 'Ni bilo mogoče najti izdelkov, ki ustrezajo SKU-jem.',
    errorAddingToCart: 'Napaka',
    failedToAddToCart: 'Izdelkov ni bilo mogoče dodati v košarico. Prosimo, poskusite znova.',
    addingToCart: 'Dodajanje v košarico...',
    // File info
    fileSelected: '{name} izbrano za obdelavo',
    fileSize: '{size} bajtov',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'Prenos predloge',
    templateWillBeImplemented: 'Prenos predloge bo implementiran v fazi 7',
    // Additional validation
    validationFailed: 'Preverjanje ni uspelo',
    // Template download
    templateDownloaded: 'Predloga uspešno prenesena',
    templateDownloadError: 'Predloge ni bilo mogoče prenesti',
    // Template content
    sheetName: 'Množično naročilo',
    instructionsSheetName: 'Navodila',
    columnDescriptions: 'Opisi stolpcev:',
    columnHeader: 'Stolpec',
    columnRequired: 'Obvezno',
    columnOptional: 'Izbirno',
    columnDescription: 'Opis',
    templateNotes: 'Opombe:',
    templateNote1: 'Prva vrstica mora vsebovati naslove stolpcev natanko tako, kot je prikazano',
    templateNote2: 'Podatki se začnejo v vrstici 2',
    templateNote3: 'SKU mora ustrezati obstoječim kodam izdelkov v sistemu',
    templateNote4: 'Količina mora biti pozitivno celo število med 1 in 9999',
    templateNote5: 'Dovoljenih največ 1000 vrstic na datoteko',
    templateNote6: 'Shranite kot .xlsx ali .csv format',
    stockAvailabilityWarning: 'Dejanska razpoložljivost zaloge bo preverjena na naslednji strani blagajne.',
    outOfStock: 'Razprodano',
    insufficientStock: 'Nezadostna zaloga: {available} na voljo, {requested} zahtevano',
  },
  orderExport: {
    export: 'Izvozi naročilo',
    exportOrder: 'Izvozi podatke o naročilu',
    exportAsCSV: 'Izvozi kot CSV',
    exportAsExcel: 'Izvozi kot Excel',
    exportForReorder: 'Izvozi za množični uvoz',
    detailed: 'Vse podrobnosti',
    simpleFormat: 'Format za uvoz',
  },
};
